import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/contexts/CartContext";
import { CheckCircle2 } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [amount, setAmount] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) return;
    let attempts = 0;
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const r = await api.get(`/checkout/status/${sid}`);
        setAmount(r.data.amount || 0);
        if (r.data.payment_status === "paid") {
          setStatus("paid"); clear(); return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sid, clear]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="checkout-success-page">
      {status === "paid" ? (
        <>
          <CheckCircle2 size={64} className="mx-auto text-[color:var(--hb-royal)] mb-4"/>
          <h1 className="font-display text-5xl text-[color:var(--hb-navy)]">Thank You for Your Business</h1>
          <p className="text-sm text-neutral-600 mt-4">We hope you enjoy your Hampton Blu Creations gear.</p>
          <p className="mt-2 text-lg">Amount: ${amount.toFixed(2)}</p>
          <Link to="/" className="hb-btn-primary mt-8 inline-block">Continue Shopping</Link>
        </>
      ) : status === "polling" ? (
        <p className="text-sm text-neutral-500">Confirming your payment…</p>
      ) : (
        <>
          <h1 className="font-display text-4xl text-[color:var(--hb-navy)]">Payment {status}</h1>
          <p className="text-sm mt-4 text-neutral-600">If this seems wrong, please contact support.</p>
          <Link to="/cart" className="hb-btn-secondary mt-8 inline-block">Back to Cart</Link>
        </>
      )}
    </div>
  );
}
